import React from 'react';
import Header from './Header';
import TaskContainer from './TaskContainer';

const Page = () => {
  return (
    <>
      <Header />
      <TaskContainer />
    </>
  );
};

export default Page;
